import { render, staticRenderFns } from "./SupportFaqCreateEdit.vue?vue&type=template&id=123a0176&"
import script from "./SupportFaqCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SupportFaqCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./SupportFaqCreateEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VTextField})
